module.exports = __webpack_public_path__ + "static/media/carro_3.ac01752c.png";